import {
    scrollPivotTablesToLatest,
    waitForPivotTablesScrolledToLatest,
} from './scrollPivotTablesToLatest';

const PRINT_BODY_CLASS = 'mtska-dashboard-report-printing';

export const printDashboardReportElement = ({ documentTitle, onAfterPrint } = {}) => {
    const previousTitle = document.title;
    const printRoot = document.querySelector('.mtska-dashboard-print-target');

    if (documentTitle) {
        document.title = documentTitle;
    }

    const cleanup = () => {
        document.body.classList.remove(PRINT_BODY_CLASS);
        document.title = previousTitle;
        window.removeEventListener('afterprint', cleanup);
        onAfterPrint?.();
    };

    const runPrint = () => {
        window.addEventListener('afterprint', cleanup);
        document.body.classList.add(PRINT_BODY_CLASS);
        window.print();
    };

    window.removeEventListener('afterprint', cleanup);

    waitForPivotTablesScrolledToLatest(printRoot)
        .then(() => {
            scrollPivotTablesToLatest(printRoot);
            requestAnimationFrame(() => {
                requestAnimationFrame(runPrint);
            });
        })
        .catch(() => {
            scrollPivotTablesToLatest(printRoot);
            runPrint();
        });
};
